import { render, staticRenderFns } from "./commodity-inventory-summaries.html?vue&type=template&id=82ca2960&scoped=true&"
import script from "./commodity-inventory-summaries.ts?vue&type=script&lang=js&"
export * from "./commodity-inventory-summaries.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ca2960",
  null
  
)

export default component.exports